







































/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import InputRegisterCode from '@/components/molecules/InputRegisterCode.vue'
import NextButton from '@/components/atoms/NextButton.vue'
import { mapState } from 'vuex'
import { okasanAccountNumber } from '@/utils/Validator'

type Data = {
  inputLabel: string;
  placeholder: string;
};

export default Vue.extend({
  name: 'RegisterCodeRegistrationOkasan',
  components: {
    InputRegisterCode,
    NextButton
  },
  props: {
    registerCode: String,
    errorMessage: String
  },
  data (): Data {
    return {
      inputLabel: 'お客様口座番号',
      placeholder: '123456789'
    }
  },
  computed: {
    ...mapState(['serviceName'])
  },
  methods: {
    changeRegisterCode: function (registerCode: string) {
      this.$emit('change', registerCode)
    },
    checkRegistrationCode () {
      const registrationCode = this.registerCode
      let errors = ''
      if (!registrationCode || !okasanAccountNumber(registrationCode)) {
        errors = '半角数字4～9桁で入力して下さい'
      }
      this.$emit('error', errors)
    },
    submit () {
      this.checkRegistrationCode()
      this.$emit('submit')
    }
  }
})
